import React from 'react'
import styled from 'styled-components'
import previewImage from '../../assets/images/special-purhcase-preview.png'
import { CheckCircleTwoTone } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import GrowthEngineHumanDemoRow from 'src/components/growthEngine/GrowthEngineHumanDemoRow'

const Container = styled.div`
  padding: 2rem;
  border: 1px solid #ddd;
  border-radius: 12px;
  background-color: #fff;
  max-width: 700px;
  margin: 0 auto;
  text-align: center;
`

const Title = styled.h1`
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
`

const Subheading = styled.p`
  color: #888;
  font-size: 0.9rem;
  margin-bottom: 2rem;

  &::before {
    content: '🔒 ';
  }
`
const Benefits = styled.ul`
  list-style: none;
  padding: 0;
`

const BenefitItem = styled.li`
  display: flex;
  align-items: start;
  gap: 0.6rem;
  margin-bottom: 0.5rem;
  font-size: 1rem;
  color: #333;
`
const FeatureCard = styled.div`
  background-color: #f9f9f9;
  padding: 1.8rem;
  border-radius: 12px;
  margin-bottom: 2rem;
`

const Headline = styled.h2`
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
`

const Body = styled.div`
  font-size: 0.9rem;
  line-height: 1.6;
  text-align: left;
  max-width: 500px;
  margin: 0 auto 1.5rem;
`

const CTASection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
`

const PrimaryButton = styled.button`
  background-color: ${({ theme }) => theme.colours.lettuceGreen};
  color: white;
  padding: 0.9rem 1.2rem;
  font-size: 1rem;
  border: none;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colours.lettuceGreen};
  }
`

const PreviewWrapper = styled.div`
  margin-top: 2rem;
  position: relative;
  border-radius: 1rem;
  overflow: hidden;
  max-height: 250px;
`

const PreviewImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  filter: blur(0.8px);
  object-fit: cover;
`

const PreviewOverlay = styled.div`
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
  background: rgba(51, 51, 51, 0.9);
  color: white;
  font-size: 0.75rem;
  padding: 0.3rem 0.6rem;
  border-radius: 0.5rem;
  z-index: 2;
`

const SpecialPurchaseLimit = () => {
  const venueId = useSelector(state => state.venue?.venue?._id)
  const history = useHistory()
  return (
    <Container>
      <Title>Special Purchases – Manager Approval Made Easy</Title>
      <Subheading>Available on Pro Plan Only</Subheading>

      <FeatureCard>
        <Headline>
          Need to buy something big? Don&apos;t get stuck in the inbox.
        </Headline>
        <Body>
          Fridge broken? Need a new fryer, oven, or generator?
          <br />
          <br />
          <strong>Special Purchases</strong> lets you submit high-value requests
          directly to your manager from inside OMS—no lost emails, no messy
          WhatsApps, no delays.
          <br />
          <br />
          <Benefits>
            <BenefitItem>
              <CheckCircleTwoTone
                twoToneColor='#52c41a'
                style={{ marginTop: 3 }}
              />{' '}
              Create requests for non-standard items
            </BenefitItem>
            <BenefitItem>
              <CheckCircleTwoTone
                twoToneColor='#52c41a'
                style={{ marginTop: 3 }}
              />{' '}
              Attach notes, files, or supplier quotes
            </BenefitItem>
            <BenefitItem>
              <CheckCircleTwoTone
                twoToneColor='#52c41a'
                style={{ marginTop: 3 }}
              />{' '}
              Get fast, trackable manager approvals
            </BenefitItem>
            <BenefitItem>
              <CheckCircleTwoTone
                twoToneColor='#52c41a'
                style={{ marginTop: 3 }}
              />{' '}
              Keep a paper trail for every big-ticket spend
            </BenefitItem>
          </Benefits>
          <br />
          <br />
          Perfect for chefs, GMs, and ops teams who want to stay in control
          without chasing paperwork.
        </Body>
        <PreviewWrapper>
          <PreviewImage src={previewImage} alt='Special Purchases preview' />
          <PreviewOverlay>Demo preview – Pro plan</PreviewOverlay>
        </PreviewWrapper>
        <CTASection>
          <PrimaryButton
            onClick={() => history.push(`/v/${venueId}/subscriptions`)}
          >
            🔓 Upgrade to Pro Plan
          </PrimaryButton>
          <GrowthEngineHumanDemoRow align='center' />
        </CTASection>
      </FeatureCard>
    </Container>
  )
}

export default SpecialPurchaseLimit
